import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { ChangePlanStateOptions } from 'webapp/services/billing';
import { Severity } from 'webapp/services/logger';

export default class SettingsBillingCallbackRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;
	@service('logger') declare loggerService: Service.Logger;

	override afterModel() {
		const searchParams = new URLSearchParams(window.location.search),
			isSuccess = searchParams.get('success') === 'true';

		this.navigationService.replaceRoute('settings.billing.index');

		if (isSuccess) {
			const encodedState = searchParams.get('state') || '';

			let state: ChangePlanStateOptions = {};
			try {
				state = JSON.parse(atob(encodedState)) as ChangePlanStateOptions; // base64 decode
			} catch (_e) {
				if (encodedState) {
					this.loggerService.logError(
						'Checkout callback state decode error',
						{ encodedState },
						Severity.WARNING,
					);
				}
			}

			this.billingService.handleCheckoutCallback(state);
		}
	}
}
